import React from 'react';
import { GetBrandedAppName, GetBrandedCompanyName, GetBrandedTutorName } from '../../services/BrandingService';
import { withTranslation } from 'react-i18next';

// TODO Implement empty state for each student who isn't associated with a score ASAP,
// and stop using this component (tracking and benchmark)
class PageStatus extends React.Component {
  render() {
    let title = this.props.t("no_scores_available");
    let endText = this.props.t("assessments_must_clear");
    if(this.props.equated) {
      title = this.props.t("no_adjusted_scores");
      endText = 'Switch to the "Unadjusted (raw scores)" score type to view reporting on all activity.';
      endText = this.props.t("switch_to_unadjusted");
    }

    if(this.props.isOnlyEarlyReader) {
      title = 'The metric you\'ve selected is not supported for early readers.';
      endText = 'Please switch to ARM to view this student\'s activity history and progress.';
      return (
        <div className="reportsNoStudentsNotice">
          <div> {title} </div>
          Once your student has completed an activity outside of the early reader skill scaffold, you will be able to view this metric. {endText}
        </div>
      );
    } else if(this.props.isAggregateReport) {
      let promptText = this.props.t("work_with_amira");
      if(this.props.equated) {
        promptText = this.props.t("complete_equated_activity");
      }
      return (
        <div className="reportsNoStudentsNotice">
          <div> {title} </div>
          {this.props.t("once_your_students")} {promptText}, {this.props.t("you_can_view_their")} {this.props.viewText} {this.props.t("here")}. {endText}
        </div>
      );
    } else {
      let promptText = this.props.t("works_with_amira");
      if(this.props.equated) {
        promptText = this.props.t("completes_equated_activity");
      }
      return (
        <div className="reportsNoStudentsNotice">
          <div> {title} </div>
          {this.props.t("once_your_student")} {promptText}, {this.props.t("you_can_view_their")} {this.props.viewText} {this.props.t("here")}. {endText}
        </div>
      );
    }

  }
}

export default withTranslation("reports")(PageStatus)